/* 
    This is the site map 

    May 24, 2024 * Bryan Lilly

    Route Array is going to be generated client side - reduce the data transfer on large jobs

    1)get the jobs for jobID
    2)get AGM data and SC data from server based on JobID
    3)calculate Route using util functions - nearest neighbour.
*/
//components
import Select from 'react-select';
import MapComponent from "../components/maps/MapComponent";
import { PageHeader } from '../components/ui/layout/PageHeader';
import { SelectContainer } from '../components/ui/layout/SelectContainer';
import { PageContainer } from '../components/ui/layout/PageContainer';
import Label from '../components/ui/labels/Label';
//hooks/context
import { useEffect, useState } from 'react';
import { useError } from '@contexts/ErrorContext';
import useJobOptions from '../hooks/useJobOptions';
import useSiteMapRoute from '../hooks/useSiteMapRoute';
import { MapControlProvider } from '../contexts/MapControlContext';
import { useUser } from '@contexts/UserContext';
//utils
import { fetchJobData } from '@utils/jobs/fetchJobData';

/**
 * Map that shows the pipeline with AGMs, Subchains, and POIs for a job. No moving PIG on this page.
 * 
 * @returns {JSX.Element}
 * 
 * @category Pages
 */
export const SiteMap = () => {
    const { jobNameOptions } = useJobOptions();
    const {
        fetchRouteArr
    } = useSiteMapRoute();

    const [selectedJob, setSelectedJob] = useState(null);
    const [gglKey, setGglKey] = useState(1);
    const {storedJob, setStoredJob} = useUser()
    const {showError} = useError()

    const handleJobSelected = (job) => {
        fetchJobData(job, showError, setSelectedJob, setStoredJob)
    }

    useEffect(() => {
        if (selectedJob) {
            setGglKey(gglKey + 1);
            fetchRouteArr(selectedJob.value.toString());
        }
    }, [selectedJob]); //eslint-disable-line

    useEffect(() => {
        document.title = `MarTrak - Site Map`

        //if a job was previously selected and added to UserContext, pull it in here
        if(storedJob){
            fetchJobData(storedJob, showError, setSelectedJob, setStoredJob)
        }
    }, []);

    return (
        <>
            <PageHeader pageTitle="Site Map" />

            <PageContainer>
                <Label>Select A Job</Label>

                <SelectContainer>
                    <Select
                        options={jobNameOptions}
                        onChange={handleJobSelected}
                        value={selectedJob}
                    />
                </SelectContainer>

            </PageContainer>

            <div className='mb-20'>

            <hr style={{margin: "0 var(--left-right-margin) 1rem"}}/>

                <MapControlProvider>
                    <MapComponent
                        key={gglKey}
                        selectedJob={selectedJob}
                        liveWPig={false}
                        poiMap={true}
                    // selectedRun={selectedRun}
                    />
                </MapControlProvider>
            </div>
        </>
    )
}